module.exports = "/images/contract.jpg?92bdea9c7eea7d19427bbf55d7d229e8";